import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme, { colors: any }>((theme) => ({
  main: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    alignItems: 'center',
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  textTitleInitial: {
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: 'Roboto',
    padding: '10px 0px 0px 3px',
    marginBottom: 5,
    fontWeight: 700,
    color: (props) => props.colors.textBody,
    left: 8,
    fontSize: theme.typography.pxToRem(36),
    '&::after': {
      content: '""',
      display: 'block',
      width: 4,
      height: 30,
      backgroundColor: (props) => props.colors.accentColor,
      position: 'absolute',
      bottom: 11,
      marginLeft: -14,
      left: 5,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(28),
      width: '85%',
      marginBottom: 19,
      '&::after': {
        bottom: 4,
      },
    },
  },
  boxCards: {
    display: 'flex',
    justifyContent: 'center',
    gap: '13px 16px',
    margin: '50px 0px 50px 0px',
    [theme.breakpoints.down('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 254px)',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
  },
  card: {
    borderRadius: 10,
    textTransform: 'capitalize',
    height: 147,
    width: 254,
    color: (props) => props.colors.accentColor,
    fontSize: theme.typography.pxToRem(24),
    background: (props) => props.colors.colorGradient,
    transition: 'background 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(90deg, #472774, #192844 67.81%)',
    },
  },
  cardTitle: {
    fontSize: theme.typography.pxToRem(18),
    textTransform: 'uppercase',
    fontWeight: 700,
  },
}))
